export const API_ROUTES = {
  public: {
    private: false,
    routes: {
      offices: "offices",
      products: "products",
      alertMessage: "alert/active"
    }
  },
  administrator: {
    private: true,
    routes: {
      register: "admin/register",
      certificates: "certificates",
      redeem: "redeem",
      alertMessage: "alert",
      logAcceptance: "log-acceptance",
      changePermission: "log-acceptance/permission",
      deleteUserData: "log-acceptance/delete",
      snrUsers: "snrUsers",
      statistics: "statistics/by-source",
      pushListToQueue : "robot/push-list-to-queue",
      getReprocessStatus : "robot/get-reprocess-status",
      deletListToQueue : "robot/delete-list-to-queue",
      combos: "combos-management"
    }
  },
  certificates: {
    private: false,
    routes: {
      download: "certificates/download",
      getCertificate: "certificates/getCertificate",
      registerByDocument: "certificates/register-by-document",
      recoverRequestsByEmail: "certificates/recover-requests-by-email",
      resendCode: "certificates/resend-code"

    }
  },
  request: {
    private: true,
    routes: {
      all: "request/all",
      details: "request/detail"
    }
  },
  civilRegistry: {
    private: true,
    routes: {
      all: "civilRegistry",
    }
  },
  auth: {
    private: false,
    routes: {
      login: "admin/login",
      publicKey: "auth/public-key",
      session: "auth/session"
    }
  },
  redeem: {
    private: false,
    routes: {
      validate: "redeem/validate",
      download: "redeem/download"
    }
  },
  paymentProcess: {
    private: false,
    routes: {
      pay: "payment-process/pay",
      banks: "payment-process/banks",
      transaction: "payment-process/transaction",
      sendPDF: "payment-process/sendPDF"
    }
  },
  refund: {
    private: true,
    routes: {
      list: "refund/list",
      pending: "refund/pending",
      processDetail: "refund/process-detail",
      revertStatus: "refund/revert-status",
      resolve: "refund/resolve",
      config: "refund/config",
      processFile: "refund/process-file",
      // New Return Request Routes
      returnRequestsPending: "refund/return-requests/pending",
      returnRequestsDetail: "refund/return-requests/detail",
      returnRequestsResolve: "refund/return-requests/resolve",
      returnRequestsRevert: "refund/return-requests/revert",
      returnRecords: "refund/return-records",
      refundStates: "refund/refund-states"
    }
  },
  refundFiles: {
    private: true,
    routes: {
      list: "refund-files",
      manualGenerate: "refund-files/manual-generate"
    }
  },
  rcRefund: {
    private: true,
    routes: {
      returnRequestsPending: "rc-refund/return-requests/pending",
      returnRequestsDetail: "rc-refund/return-requests/detail",
      returnRequestsResolve: "rc-refund/return-requests/resolve",
      returnRequestsRevert: "rc-refund/return-requests/revert",
      returnRecords: "rc-refund/return-records"
    }
  },
  cookieConsent: {
    private: false,
    routes: {
      save: "cookie-consents"
    }
  },
};